// Países fijos del selector de país global (los que tienen fuentes propias).
// Además, el selector suma solo cualquier país con eventos vigentes (GET
// /events/countries, ver country-store): un evento creado en Lima hace
// aparecer Perú sin tocar esta lista. Mismo criterio en la app
// (ciudad-viva-mobile/lib/event-countries.ts). Módulo sin "use client" para
// que también lo usen las páginas del servidor.
export const EVENT_COUNTRIES = ["CL", "US", "MX", "AR"] as const;
export const DEFAULT_COUNTRY = "CL";
